import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

export default function () {
	const store = useStore();
	const router = useRouter();
	const route = useRoute();
	const bookSteps = computed(() => store.state.book.bookSteps);
	const etcBookSteps = computed(() => store.state.book.etcBookSteps);
	const nowBookSteps = computed(() => {
		return route.fullPath.includes('etc')
			? etcBookSteps.value
			: bookSteps.value;
	});
	const nextBookStep = RouteName => {
		if (!RouteName) {
			return;
		}
		const index = nowBookSteps.value.findIndex(
			bookStep => bookStep.page === RouteName,
		);
		const { page } = nowBookSteps.value[index + 1];
		router.push({ name: page, params: { isNormalBookStep: true } });
	};
	return { nextBookStep };
}
